import React from 'react';
import PreLoginPage from './../core/PreLoginPage';
import { Table } from 'reactstrap';

// ES6 class-style

class ng_EventDetails extends PreLoginPage {
    render() {
        const eventDate = new Date();
        console.log("eventDate == ", eventDate)
        return (
            <div data-p-ga="" id="EventDetails">
                <div className="container eventSection">
                    <Table>
                        <tbody>
                            <tr>
                                <td className="date">{this.rb("event.heading.ng1")}
                                    <span className='coloncontainer'>{this.rb("event.heading.colon")}</span>
                                </td>
                                {/* <td className='coloncontainer'>{this.rb("event.heading.colon")}</td> */}
                                <td >{this.rb("event.heading.ng1_1")}</td>
                            </tr>
                            <tr>
                                <td className="date">{this.rb("event.heading.ng2")}
                                    <span className='coloncontainer'>{this.rb("event.heading.colon")}</span>
                                </td>
                                {/* <td className='coloncontainer'>{this.rb("event.heading.colon")}</td> */}
                                <td >{this.rb("event.heading.ng2_2")}</td>
                            </tr>
                            <tr>
                                <td className="date">{this.rb("event.heading.ng3")}
                                    <span className='coloncontainer'>{this.rb("event.heading.colon")}</span>
                                </td>
                                {/* <td className='coloncontainer'>{this.rb("event.heading.colon")}</td> */}
                                <td >{this.rb("event.heading.ng3_3")}</td>
                            </tr>
                            <tr>
                                <td className="date">{this.rb("event.heading.ng4")}
                                    <span className='coloncontainer'>{this.rb("event.heading.colon")}</span>
                                </td>
                                {/* <td className='coloncontainer'>{this.rb("event.heading.colon")}</td> */}
                                <td > {this.rb("event.heading.ng4_4")}</td>
                            </tr>

                        </tbody>
                    </Table>
                    {/* <span>{this.rb("event.subheading1.za1")}</span>
                    <span>{this.rb("event.subheading1.za2")}</span>
                    <span>{this.rb("event.subheading1.za3")}</span>
                    <span>{this.rb("event.subheading1.za4")}</span> */}
                </div>

            </div>
        );
    }
}

export default ng_EventDetails;


// WEBPACK FOOTER //
// ./src/views/ng/ng_EventDetails.js